import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <p className="footer-blessing">लोकाः समस्ताः सुखिनो भवन्तु</p>
        <p className="footer-translation">May all beings everywhere be happy and free</p>
        
        <div className="footer-links">
          <a href="#">About Heritage</a>
          <a href="#">API Access</a>
          <a href="#">Contribute</a>
          <a href="#">Contact</a>
        </div>
        
        <p style={{ opacity: 0.5, fontSize: '0.85rem', marginTop: '2rem' }}>
          © 2024 Digital Heritage · Preserving Eternal Wisdom
        </p>
      </div>
    </footer>
  );
};

export default Footer; 